const columns = () => {
  return [
    {
      title: '分类名称',
      name: 'name',
      dataIndex: 'name',
      searchItem: {},
      tableItem: {
        width: 220
      }
    },
    {
      title: '状态',
      name: 'state',
      dataIndex: 'state',
      tableItem: {
        width: 100
      },
      dict: [
        { code: 1, codeName: "有效" },
        { code: 0, codeName: "无效" }
      ]
    },
    {
      title: '描述',
      name: 'intro',
      dataIndex: 'intro',
      tableItem: {
        width: 312
      }
    }
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'questionType/listByPage',
    ...api
  }
}

const categoryInfo = (self, api, attrs) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api),
    ...attrs
  }
}

export default categoryInfo
